import { render } from "./MyMessages.vue?vue&type=template&id=e398e2c4&scoped=true"
import script from "./MyMessages.vue?vue&type=script&lang=js"
export * from "./MyMessages.vue?vue&type=script&lang=js"

import "./MyMessages.vue?vue&type=style&index=0&id=e398e2c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e398e2c4"]])

export default __exports__